import { convertDate, titleCase } from "../../../Utils/titleCaseFunction";
import { useEffect, useState } from "react";
import axios from "axios";
import config from "../../../Helpers/config.json";
import { errorMessages } from "../../../Helpers/ErrorMessages";
import { useAddCustomer } from "../../Customer/CustomHooks/useAddCustomer";
import { v4 as uuidv4 } from "uuid";

export const useReusableNewSales = (
  actions,
  invoice_number = "",
  is_cash = false,
) => {
  const defaultCustomer = is_cash
    ? { customer_name: "Walk-in Customer", customer_id: "1" }
    : "";
  const initialState = [
    {
      product_name: "",
      batch_id: "",
      batch_info: [],
      available_quantity: "",
      expiry: "",
      unit: "",
      product_quantity: "",
      product_rate: "",
      discount: "",
      total_price: "",
      discount_type: 1,
      related_product: "",
      total_discount: 0,
      tax: "",
      dosage: "",
      product_id: "",
      showProduct: false,
      isError: false,
      isPriceLower:false,
      isDiscountable:false,
      uuid_id: uuidv4(),
      original_rate:0,
      discount_rate:0,
      batch_details_id:"",
    },
  ];
  const [paytype, setPayType] = useState("");
  const [customer, setCustomer] = useState(defaultCustomer);
  const [showCustomer, setShowCustomer] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [rows, setRows] = useState(initialState);
  const [drugs, setDrugs] = useState([]);
  const [state, setState] = useState({
    invoice_date: convertDate(),
    inva_details: "",
  });
  const [totals, setTotals] = useState({
    grand_total_price: 0,
    n_total: 0,
    change: 0,
    due_amount: 0,
    paid_amount: "",
    previous_amount: 0,
    total_discount_amount: 0,
  });
  const [customerDetails, setCustomerDetails] = useState({
    credit_limit: 0,
    isCreditError: false,
  });
  const { customerProps } = useAddCustomer(actions, "new-customer");
  const [prevProducts, setPrevProducts] = useState([]);
  const [prevAmount, setPrevAmount] = useState(0);
  const [amountPaid, setAmountPaid] = useState(0);
  const [paymentType, setPaymentType] = useState("");
  const [isBlocking, setIsBlocking] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);

  const groupByProductId = (arr = [], product_details = []) => {
    let empty = [];
    let obj = {};
    // console.log(arr);
    for (let j = 0; j < product_details.length; j++) {
      for (let i = 0; i < arr.length; i++) {
        // console.log("arr", arr[i].batch);
        if (product_details[j].product_id === arr[i].product_id) {
          obj = { ...product_details[j], ...arr[i] };
        }
      }
      empty.push(obj);
    }

    // console.log("empty", empty);
    return empty;
  };

  // using the purchase_detail_id to compare now instead of batch_id
   // using the batch_details_id to compare now instead of batch_id
   const getBatchDetails = (b_id, batch_data = []) => {
    // console.log(`batch_details`, b_id, batch_data)

    const arr = batch_data
      .filter((item) => item.batch_details_id === b_id)
      .map((item) => ({
        ...item,
        expiry: item.expiry_date,
        available_quantity: item.stock,
      }));

    // console.log(arr);

    return arr[0];
  };




const handleSearch = async () => {
  if (!searchTerm.trim()) return;
  try {
    const res = await fetch(`${config.epharmUrl}/Cproduct/find_product_details?search=${searchTerm}`);
    const data = await res.json();
    setResults(data);
  } catch (err) {
    console.error("Error fetching product details:", err);
  }
};

  const handleChangeSearch = (e) => {
    setSearchTerm(e.target.value);
  };


  const handleGetCustomer = (event) => {
    if (!event["innerText"]) {
      setCustomer({ customer_name: "", customer_id: "" });
      setShowCustomer(false);
      return;
    }
    const { innerText, value } = event;
    const id = value ? value.split("-")[0] : "";
    const limit = value ? value.split("-")[1] : 0;
    setCustomer({ customer_name: innerText, customer_id: id });
    setCustomerDetails({ ...customerDetails, credit_limit: parseInt(limit) });
    return axios.get(`${config.epharmUrl}/Cinvoice/outstanding_balance`, {
      params: { customer_id: id },
    });
  };

  useEffect(() => {
    if (!invoice_number) {
      return;
    }
    console.log()
    const storage = JSON.parse(sessionStorage.getItem(invoice_number));
    const item = storage ? storage : {};
    console.log("item ",item)
    const customer_details = item["customer"] ? item["customer"] : {};
    const product_details = item["products"] ? item["products"] : {};
    const obj = {
      innerText: customer_details.customer_name,
      value: `${customer_details.customer_id}-${customer_details.credit_limit}`,
    };
    const amount_paid = customer_details?.amount_paid
      ? customer_details?.amount_paid
      : 0;
    const pay_type = customer_details?.payment_type
      ? customer_details?.payment_type
      : 0;
      if (customer_details.customer_id) {
        setCustomer({
          customer_name: customer_details.customer_name,
          customer_id: customer_details.customer_id,
        });
        setCustomerDetails({
          ...customerDetails,
          credit_limit: parseInt(customer_details.credit_limit || 0),
        });
        // inside your useEffect
if (customer_details.date) {
  // Example: "Sun, 07 Sep 2025 09:09:54 GMT"
  const dateParts = customer_details.date.split(" "); // ["Sun,", "07", "Sep", "2025", "09:09:54", "GMT"]
  
  const day = dateParts[1]; // "07"
  const monthStr = dateParts[2]; // "Sep"
  const year = dateParts[3]; // "2025"

  // Map month abbreviation to number
  const monthMap = {
    Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
    Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12",
  };
  const month = monthMap[monthStr];

  const formattedDate = `${year}-${month}-${day}`; // YYYY-MM-DD
  setState({ invoice_date: formattedDate, inva_details: "" });
} else {
  setState({ invoice_date: convertDate(), inva_details: "" }); // fallback
}



      }
    if (!obj.innerText) {
      return;
    }
    handleGetCustomer(obj)
      .then((response) => {
        const data = response.data;
        const dt = !data ? {} : data;
        const amount = dt.data ? dt.data : 0;
        Promise.all(
          product_details.map((item) => {
            return axios
              .post(
                `${config.epharmUrl}/Cinvoice/retrieve_product_data_inv_edit`,
                null,
                { params: { product_id: item.product_id } },
              )
              .then((response) => {
                return response;
              });
          }),
        ).then(function (result) {
          const dt = result ? result : [];
          const arr = dt.map(({ data }) => data);
          const empty = groupByProductId(arr, product_details);
          const emp = empty.map((item) => {
            // console.log("item", item);
            return {
              ...item,
              ...getBatchDetails(item.batch_details_id, item.batch),
            };
          });

          // console.log("emp", emp);

          const resultArr = groupByProductId(arr, emp);

          let productIds = resultArr.map((item) => {
            const total = +item.quantity * +item.price;
            const disc = item.discount ? item.discount : 0;
            console.log()
            const discount_amount = total * (+disc / 100);
            const dis_total = +item.quantity * +item.rate;
            const final_total = total - dis_total;

            // get batch details : batch_id and purchase_detail_id
            const get_current_batch_details = item.batch_info?.find(
              (ele) => ele.batch_details_id === item.batch_details_id
            );
            console.log("item", item);
            console.log("item.batch_details_id", item.batch_details_id);
            console.log("get_current_batch_details", get_current_batch_details);
            
            const current_batch_details = get_current_batch_details
              ? {
                  batch_id: get_current_batch_details.batch_id ?? "nop",
                  batch_details_id: get_current_batch_details.batch_details_id ?? "",
                }
              : {
                  batch_id: "nop",
                  batch_details_id: "",
                };

            // const bArr = item?.batch?.map(({batch_id}) => batch_id)
            return {
              ...item,
              product_id: item.product_id,
              // batch_id: current_batch_details.batch_id,
              product_quantity: item.quantity,
              product_rate: item.rate,
              discount: item.discount_amount,
              discount_rate:item.discount,
              total_price: dis_total,
              batch_info: item.batch,
              unit: item.unit,
              original_rate:item.price,
              total_stock: item.total_product,
              // batch_details_id: current_batch_details.batch_details_id,
              
            };
          });
          const finalProducts = productIds.map((product) => ({
            ...product,
            uuid_id: product.uuid_id || uuidv4(), // ensure every product has a unique ID
          }));
          setPrevProducts(finalProducts);
          setPrevAmount(amount);
          setAmountPaid(amount_paid);
          setPaymentType(pay_type);
        });
      })
      .catch((error) => {
        errorMessages(error, null, actions);
      });
  }, [invoice_number]);

  useEffect(() => {
    if (!invoice_number) {
      return;
    }
    setRows(prevProducts);
    setPayType(paymentType);
    calculateTotalAmounts(prevProducts, amountPaid, prevAmount);
  }, [prevAmount, prevProducts, amountPaid, paymentType]);

  const handleChangePaymentMethod = (event) => {
    const { value } = event.target;
    setPayType(value);
    setIsBlocking(true);
  };

  const handleChangeFormFields = (event) => {
    const { name, value } = event.target;
    setState({ ...state, [name]: value });
    setIsBlocking(true);
  };

  const handleChange = (event, index) => {
    const { value, name } = event.target;
    const arr = rows.map((item, idx) => {
      if (idx === index) {
        return { ...item, [name]: value };
      }
      return value;
    });
    setRows(arr);
    setIsBlocking(true);
  };


  const calculateTotalAmounts = (arr, p_amount, prev_amount) => {
    // Calculate total price using product_rate and subtract discount
    const sum = arr.reduce((a, row) => {
      const discountAmount = row.discount || 0; // discount per unit
      const total_price = (row.product_rate - discountAmount) * (row.product_quantity || 0);
      return a + total_price;
    }, 0);
  
    // Calculate total discount amount (discount * quantity)
    const discount = arr.reduce((a, row) => {
      const row_discount = (row.discount || 0) * (row.product_quantity || 0);
      return a + row_discount;
    }, 0);
  
    const net_total = sum; // total after discounts
    const amount_due = net_total - (p_amount || 0);
    const final_due = amount_due > 0 ? amount_due : 0;
  
    const change = (p_amount || 0) - net_total;
    const final_change = change > 0 ? change : 0;
  
    setTotals({
      ...totals,
      grand_total_price: sum,
      n_total: net_total,
      due_amount: final_due,
      change: final_change,
      total_discount_amount: discount,
      paid_amount: p_amount,
      previous_amount: prev_amount,
    });
  };
  
  // const calculateTotalAmounts = (arr, p_amount, prev_amount) => {
  //   console.log(arr)
  //   const sum = arr.reduce((a, row) => {
  //     return Number(a + row.total_price);
  //   }, 0);
  //   const discount = arr.reduce((a, row) => {
  //     let total_apparent = +(row.product_rate * row.product_quantity);
  //     console.log(total_apparent)
  //     let dis = !row.discount_rate ? 0 : +(row.discount_rate * total_apparent);
  //     let disc = dis / 100;
  //     return a + disc;
  //   }, 0);
  //   const net_total = sum; //+(sum + prev_amount);
  //   const amount = +(net_total - p_amount);
  //   const final_amount = amount > 0 ? amount : 0;
  //   const change = +(p_amount - net_total);
  //   const final_change = change > 0 ? change : 0;
  //   setTotals({
  //     ...totals,
  //     grand_total_price: sum,
  //     n_total: +net_total,
  //     due_amount: final_amount,
  //     change: final_change,
  //     total_discount_amount: +discount,
  //     paid_amount: p_amount,
  //     previous_amount: prev_amount,
  //   });
  // };

  const handleChangeQuantity = (event, index) => {

    const { value } = event.target;

    const { paid_amount, previous_amount } = totals;

    const updatedRows = rows.map((row, idx) => {
      if (index !== idx) {
        return row;
      }
      const discount_value = +row.discount;

      const total = +value * row?.product_rate;

      const final_total = total ;
      

      return {
        ...row,
        product_quantity: value,
        total_price: final_total,
        // discount_rate: +discount_rate,
        isError: +value > row?.available_quantity,
        
      };
    });

    setRows(updatedRows);

    calculateTotalAmounts(updatedRows, paid_amount, previous_amount);

    setIsBlocking(true);
  };
  
  
  const handleChangeRate = (event, index) => {
    const { value } = event.target;
    const { paid_amount, previous_amount } = totals;
  
    const updatedRows = rows.map((row, idx) => {
      if (index !== idx) return row;
  
      const newRate = parseFloat(value) || 0;
      console.log(" row.original_rate ",row.original_rate )

      const isPriceLower = newRate < row.original_rate;
      console.log(" isPriceLower ",isPriceLower )
  
      const appliedRate = isPriceLower ? row.original_rate : newRate; // use original_rate if lower
      const total = appliedRate * (row.product_quantity || 0);
  
      return {
        ...row,
        product_rate: newRate, // keep entered rate in field
        total_price: total,
        isPriceLower,
      };
    });
  
    setRows(updatedRows);
    calculateTotalAmounts(updatedRows, paid_amount, previous_amount);
    setIsBlocking(true);
  };



  const handleChangeDiscount = (event, index) => {
    const { paid_amount, previous_amount } = totals;
    const { value } = event.target;
    
  
    const arr = rows.map((item, idx) => {
      
      const original_rate = item.original_rate || item.product_rate;
      // console.log(" item.original_rate ", item.original_rate ," item.product_rate ",item.product_rate)
      const discount_value = +value;
  
      // Ensure discount doesn't exceed the original rate
      const unit_rate = Math.max(original_rate - Math.abs(discount_value), 0);

  
      // Calculate discount percentage
      const discount_rate = (discount_value / original_rate) * 100;
  
      // Calculate the final total
      const final_total = +item.product_quantity * unit_rate;
  
      // Validate input
      const isDiscountable = discount_value > item.product_rate;
  
      return index === idx
        ? {
            ...item,
            discount: discount_value,
            discount_rate:Math.round(discount_rate),
            total_price: final_total,
            // product_rate: unit_rate,
            original_rate,
            isDiscountable,
          }
        : item;
    });
  
    setRows(arr);
    calculateTotalAmounts(arr, paid_amount, previous_amount);
    setIsBlocking(true);
  };
  
  const handleChangeBalance = (event) => {
    const { previous_amount } = totals;
    const { value } = event.target;
    calculateTotalAmounts(rows, value, previous_amount);
    setIsBlocking(true);
  };

  const handleRetrieveCustomerInfo = (event) => {
    const customer_value = event.target ? event.target.value : event;
    setCustomer({ ...customer, customer_name: customer_value });
    if (customer_value !== "") {
      axios
        .get(`${config.epharmUrl}/Cinvoice/customer_autocomplete`, {
          params: { customer_id: titleCase(customer_value) },
        })
        .then((res) => {
          const data = res.data;
          const dt = !data ? [] : data;
          const arr = dt.map((item) => ({
            value: `${item.customer_id}-${item.credit_limit}`,
            label: item.customer_name,
          }));
          setCustomers(arr);
        })
        .catch((error) => {
          errorMessages(error, null, actions);
        });
      setShowCustomer(true);
    } else {
      setShowCustomer(false);
    }
    // setIsBlocking(true)
  };

  const handleClickCustomer = (event) => {
    const { paid_amount } = totals;
    if (!event["innerText"]) {
      return;
    }
    handleGetCustomer(event)
      .then((response) => {
        const data = response.data;
        const dt = !data ? {} : data;
        const amount = dt.data ? dt.data : 0;
        setTotals({ ...totals, previous_amount: amount });
        calculateTotalAmounts(rows, paid_amount, amount);
      })
      .catch((error) => {
        errorMessages(error, null, actions);
      });
    setShowCustomer(false);
    // setIsBlocking(true)
  };

  const [isOpen, setIsOpen] = useState(false);

  const [expiredDrugReason, setExpiredDrugReason] = useState("");

  const [clickedDrugIndex, setClickedDrugIndex] = useState(0);

  const [showExpiredDrugReasonInput, setShowExpiredDrugReasonInput] =
    useState(false);

  const [showExpiredDrugDialog, setShowExpiredDrugDialog] = useState(false);

  // const handleRetrieveDrugs = (eventTxt, index) => {
  //   let tmp = eventTxt.trim();

  //   if (tmp.includes("(")) {
  //     tmp = tmp.substring(0, tmp.indexOf("("));
  //   }

  //   const arr = rows.map((item, idx) => {
  //     if (idx === index) {
  //       if (tmp !== "") {
  //         axios
  //           .get(`${config.epharmUrl}/Cinvoice/autocompleteproductsearch_with_stock`, {
  //             params: { product_name: titleCase(tmp) },
  //           })
  //           .then((res) => {
  //             const data = res.data;

  //             const dt = !data ? [] : data;

  //             const arr = dt.map((item) => ({
  //               value: item.value,
  //               label: `${item.label}-${item.generic_name}`,
  //               generic_name: item.generic_name,
  //             }));

  //             setDrugs(arr);
  //           })
  //           .catch((error) => {
  //             errorMessages(error, null, actions);
  //           });

  //         return { ...item, product_name: tmp, showProduct: true };
  //       } else {
  //         return {
  //           ...item,
  //           product_name: tmp,
  //           showProduct: false,
  //           batch_id: "",
  //           batch_info: [],
  //           available_quantity: 0,
  //           product_rate: 0,
  //           product_quantity: "",
  //           expiry: "",
  //           unit: "",
  //           total_price: 0,
  //           discount: "",
  //         };
  //       }
  //     }

  //     return item;
  //   });

  //   // console.log(arr);

  //   setRows(arr);

  //   setIsBlocking(true);
  // };


  const handleRetrieveDrugs = (eventTxt, index) => {
    // Keep the input as-is for display (spaces included)
    let tmp = eventTxt;
  
    // Prepare a trimmed version only for API query
    let searchTxt = tmp;
    if (searchTxt.includes("(")) {
      searchTxt = searchTxt.substring(0, searchTxt.indexOf("("));
    }
    const trimmedSearch = searchTxt.trim(); // only trim for API
  
    // If there is text, call API
    if (trimmedSearch !== "") {
      axios
        .get(`${config.epharmUrl}/Cinvoice/autocompleteproductsearch_with_stock`, {
          params: { product_name: titleCase(trimmedSearch) },
        })
        .then((res) => {
          const data = res.data;
          const dt = !data ? [] : data;
  
          const arr = dt.map((item) => ({
            value: item.value,
            label: `${item.label}-${item.generic_name}`,
            generic_name: item.generic_name,
          }));
  
          setDrugs(arr);
        })
        .catch((error) => {
          errorMessages(error, null, actions);
        });
    }
  
    // Update rows with current input (spaces preserved)
    const arr = rows.map((item, idx) => {
      if (idx === index) {
        if (tmp !== "") {
          return { ...item, product_name: tmp, showProduct: true };
        } else {
          return {
            ...item,
            product_name: tmp,
            showProduct: false,
            batch_id: "",
            batch_info: [],
            available_quantity: 0,
            product_rate: 0,
            product_quantity: "",
            expiry: "",
            unit: "",
            total_price: 0,
            discount: "",
          };
        }
      }
      return item;
    });
  
    setRows(arr);
    setIsBlocking(true);
  };
  
  const handleClickDrugTwo = (event, index) => {
    const { value, innerText } = event;

    setClickedDrugIndex(index);

    const updatedRows = rows.map((row, idx) =>
      idx === index
        ? {
            ...row,
            showProduct: false,
            product_id: value,
            product_name: innerText,
          }
        : row,
    );

    setRows(updatedRows);

    axios
      .post(`${config.epharmUrl}/Cinvoice/retrieve_product_data_inv`, null, {
        params: { product_id: value },
      })
      .then((response) => {
        const data = response?.data;

        let batches = data?.batch ?? [];

        batches =
          batches.length > 0
            ? batches.map(({ batch_id, batch_details_id }) => ({
                batch_id,
                batch_details_id,
              }))
            : [];

        const batchID = batches[0]?.batch_details_id ?? "";

        const batch = getBatchDetails(batchID, data?.batch ?? []);

        // console.log(batch)

        if (batch?.days_until_expiry <= batch.expiry_days) {
          setShowExpiredDrugDialog(true);
          //     ...item,
          //     available_quantity: "",
          //     expiry: "",
          //     expired: true,
          //     unit: dt.unit ? dt.unit : "",
          //     batch_id: "",
          //     dosage: "",
          //     total_stock: dt.total_product ? dt.total_product : 0,
          //     batch_info: batchArr,
          //     product_rate: dt.price,

          // return;
        }

        // console.log(updatedRows.map((row, idx) => index === idx ? ({
        //   ...row,
        //   available_quantity: row?.stock ?? 0,
        //   expiry: batch?.expiry,
        //   unit: data.unit ?? "",
        //   batch_id: batch?.batch_id ?? "",
        //   dosage: "",
        //   total_stock: data?.total_product ?? 0,
        //   batch_info: data?.batch ?? [],
        //   product_rate: data.price,
        //
        // }) : row))

        return setRows(
          updatedRows.map((row, idx) =>
            index === idx
              ? {
                  ...row,
                  ...getBatchDetails(batch, data?.batch ?? []),
                  batch_info: data?.batch ?? [],
                  unit: data.unit ?? "",
                  total_stock: data.total_product ?? 0,
                  product_rate: data?.price ?? "",
                  original_rate: data?.price ?? "",
                  available_quantity: batch?.stock ?? 0,
                  expiry: batch?.expiry,
                  batch_id: batch?.batch_id ?? "",
                  dosage: "",
                  batch_details_id: batch?.batch_details_id ?? "",
                }
              : row,
          ),
        );
      })
      .catch((error) => {
        errorMessages(error, null, actions);
        // console.log(error)
      });
  };
  // console.log(rows)

  const handleClickDrug = (event, index) => {
    handleClickDrugTwo(event, index);
  };

  // batch_value now holds the purchase_detail_id instead of batch_id
  const handleChangeBatch = (event, index) => {
    const batch_value = event.target ? event.target.value : event;

    const arr = rows.map((item, idx) => {
      const batchObj = getBatchDetails(event.target.value, item.batch_info);

      const obj = batchObj ? batchObj : {};

      const exp_date = obj.expiry ? obj.expiry : "";

      const daysLeft = Math.floor(
        (Date.parse(exp_date) - Date.now()) / (24 * 60 * 60 * 1000),
      );
      if (obj?.days_until_expiry <= obj.expiry_days) {
        setShowExpiredDrugDialog(true);
      }
      if (idx === index) {
        if (daysLeft < 0) {
          return {
            ...item,
            available_quantity: "",
            expiry: "",
            expired: true,
            batch_id: "",
            batch_details_id:"",
            dosage: "",
          };
        } else {
          return {
            ...item,
            ...getBatchDetails(batch_value, item.batch_info),
            batch_id: obj?.batch_id || "",
            expired: false,
            batch_details_id:obj?.batch_details_id || "",
          };
        }
      }

      return item;
    });

    // const isExpired = arr.every((item) => item.expired);
    //
    // if (isExpired) {
    //   actions.snackbarActions.infoSnackbar(
    //     "Batch Expired, Please Choose another"
    //   );
    // }

    setRows(arr);

    setIsBlocking(true);
  };

  const handleAddRow = () => {
    const item = {
      product_name: "",
      batch_id: "",
      batch_info: [],
      available_quantity: "",
      expiry: "",
      unit: "",
      product_quantity: "",
      product_rate: "",
      discount: 0,
      discount_rate:0,
      total_price: "",
      discount_type: 1,
      total_discount: 0,
      product_id: "",
      tax: 0,
      dosage: "",
      showProduct: false,
      uuid_id: uuidv4(),
    };
    setRows((prevRows) => [...prevRows, item]);

    // setRows([...rows, item]);
    setIsBlocking(true);
  };
  const handleAddFourRows = () => {
    const createItem = () => ({
      product_name: "",
      batch_id: "",
      batch_info: [],
      available_quantity: "",
      expiry: "",
      unit: "",
      product_quantity: "",
      product_rate: "",
      discount: 0,
      discount_rate: 0,
      total_price: "",
      discount_type: 1,
      total_discount: 0,
      product_id: "",
      tax: 0,
      dosage: "",
      showProduct: false,
      uuid_id: uuidv4(),
    });
  
    setRows(prevRows => [...prevRows, createItem(), createItem(), createItem(), createItem()]);
    setIsBlocking(true);
  };
  
  const handleRemoveSpecificRow = (idx) => {
    const { paid_amount, previous_amount } = totals;
    const updatedRows = [...rows];
    const arr = rows.filter((item) => item.uuid_id !== rows[idx].uuid_id);

    // updatedRows.splice(idx, 1);
    // const arr = rows.filter((_, index) => index !== idx)
    setRows(arr);
    // console.log("index", idx);
    calculateTotalAmounts(arr, paid_amount, previous_amount);
    setIsBlocking(true);
  };

  const handleCloseExpiredDialog = () => {
    setIsOpen(false);
  };

  const openExpiredDrugReasonInput = () => {
    setShowExpiredDrugReasonInput(true);
  };

  const closeExpiredDrugReasonInput = () => {
    setShowExpiredDrugReasonInput(false);
  };

  const openExpiredDrugDialog = () => {
    setShowExpiredDrugDialog(true);
  };

  const closeExpiredDrugDialog = () => {
    setShowExpiredDrugDialog(false);
    setShowExpiredDrugReasonInput(false);
    setExpiredDrugReason("");
  };

  const handleChangeExpiredDrugReason = (event) => {
    setExpiredDrugReason(event.target.value);

    // console.log(event.target.value)
    // debugger;

    // console.log(rows.map((row, idx) => idx === clickedDrugIndex ? ({ ...row, expiredDrugReason: event.target.value }) : row))

    setRows(
      rows.map((row, idx) =>
        idx === clickedDrugIndex
          ? { ...row, expiredDrugReason: event.target.value }
          : row,
      ),
    );
  };

  const stateVariables = {
    initialState,
    paytype,
    customer,
    showCustomer,
    rows,
    state,
    customerProps,
    customerDetails,
    totals,
    customers,
    drugs,
    handleChangeFormFields,
    handleChangePaymentMethod,
    handleChange,
    handleChangeBatch,
    handleAddRow,
    handleRemoveSpecificRow,
    handleChangeQuantity,
    handleChangeDiscount,
    handleChangeBalance,
    handleRetrieveCustomerInfo,
    handleClickCustomer,
    handleRetrieveDrugs,
    handleClickDrug,
    isBlocking,
    isOpen,
    handleCloseExpiredDialog,
    expiredDrugReason,
    showExpiredDrugReasonInput,
    showExpiredDrugDialog,
    openExpiredDrugReasonInput,
    closeExpiredDrugReasonInput,
    openExpiredDrugDialog,
    closeExpiredDrugDialog,
    handleChangeExpiredDrugReason,
    handleSearch,
    searchTerm,
    results,
    handleChangeSearch,
    handleChangeRate,
    handleAddFourRows,
  };

  const stateFunctions = {
    setRows,
    setCustomer,
    setTotals,
    setCustomerDetails,
    setIsBlocking,
  };

  return { stateVariables, stateFunctions };
};
// 289 branch
// const handleClickDrug = (event, index) => {
//   handleClickDrugTwo(event, index);
//   // const { value, innerText } = event;
  //
  // setClickedDrugIndex(index);
  //
  // if (value === "" || innerText === "") {
  //   return;
  // }
  //
  // let arr = rows.map((item, idx) => {
  //   if (idx === index) {
  //     return {
  //       ...item,
  //       showProduct: false,
  //       product_name: innerText,
  //       product_id: value,
  //     };
  //   }
  //   return item;
  // });
  //
  // axios
  //   .post(
  //     `${config.epharmUrl}/Cinvoice/retrieve_product_data_inv`,
  //     null,
  //     {
  //       params: { product_id: value },
  //     }
  //   )
  //   .then((response) => {
  //     const data = response.data;
  //
  //     const dt = !data ? {} : data;
  //
  //     const batchArr = dt.batch ? dt.batch : [];
  //
  //     if (batchArr.length > 0) {
  //       const batches =
  //         batchArr.length > 0
  //           ? batchArr.map(({ batch_id, purchase_detail_id }) => {
  //             return { purchase_detail_id, batch_id };
  //           })
  //           : [];
  //
  //       const batch = batches[0].batch_id ? batches[0].batch_id : "";
  //
  //       arr = arr.map((item, idx) => {
  //
  //         const batchObj = getBatchDetails(batch, batchArr);
  //         // console.log(batchObj)
  //
  //         const exp_date = batchObj.days_until_expiry
  //           ? batchObj.days_until_expiry
  //           : "";
  //         // const daysLeft = Math.floor(
  //         //   (Date.parse(exp_date) - Date.now()) / (24 * 60 * 60 * 1000)
  //         // );
  //
  //         if (idx === index) {
  //           // if (exp_date < 10) {
  //           //   return {
  //           //     ...item,
  //           //     available_quantity: "",
  //           //     expiry: "",
  //           //     expired: true,
  //           //     unit: dt.unit ? dt.unit : "",
  //           //     batch_id: "",
  //           //     dosage: "",
  //           //     total_stock: dt.total_product ? dt.total_product : 0,
  //           //     batch_info: batchArr,
  //           //     product_rate: dt.price,
  //           //   };
  //           // } else {
  //           return {
  //             ...item,
  //             ...getBatchDetails(batch, batchArr),
  //             expired: false,
  //             batch_info: batchArr,
  //             unit: dt.unit ? dt.unit : "",
  //             total_stock: dt.total_product ? dt.total_product : 0,
  //             batch_id: batches[0],
  //             product_rate: dt.price,
  //           };
  //           // }
  //         }
  //
  //         return item;
  //       });
  //
  //       const isExpired = arr.every((item) => item.expired);
  //
  //       if (isExpired) {
  //         // actions.snackbarActions.infoSnackbar(
  //         //   "Batch Expired, Please Choose another"
  //         // );
  //         // setIsOpen(true)
  //         // setRows(arr);
  //         setShowExpiredDrugDialog(true)
  //       }
  //
  //       setRows(arr);
  //     } else {
  //       actions.snackbarActions.infoSnackbar(
  //         "This product has no batches. Please choose another"
  //       );
  //     }
  //   })
  //   .catch((error) => {
  //     errorMessages(error, null, actions);
  //   });
  // setIsBlocking(true);
// };